import {
  ORG_PROJECTS_QUERY_KEY,
  PROJECTS_QUERY_KEY,
} from "@frontend-shared/constants";
import { EAnalyticsEvent } from "@frontend-shared/product-analytics";
import type { ICreateProjectBody } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { projectApi } from "@/api/services";
import { useProductAnalytics } from "@/hooks/use-product-analytics";

export const useCreateProject = () => {
  const { t } = useTranslation("settings");
  const queryClient = useQueryClient();
  const { capture } = useProductAnalytics();

  return useMutation({
    mutationFn: (body: ICreateProjectBody) => projectApi.create(body),
    onSuccess: (_data, variables) => {
      // NOTE: NSAI-4616 — a project is the tenant boundary every event is
      // already grouped by, so its creation was the one workspace milestone
      // measurable only indirectly. Name and uuid stay out: the count and its
      // timing are the question, not which project it was.
      capture({ event: EAnalyticsEvent.PROJECT_CREATED });

      queryClient.invalidateQueries({
        queryKey: [ORG_PROJECTS_QUERY_KEY, variables.organizationUuid],
      });
      queryClient.invalidateQueries({
        queryKey: [PROJECTS_QUERY_KEY],
      });
      toast.success(t("projects.create.success"));
    },
    meta: {
      fallbackMessage: t("projects.create.error"),
    },
  });
};
